<template>
  <div
    class="min-h-screen bg-gradient-to-br from-black via-main to-gray-900 relative overflow-hidden"
  >
    <!-- Animated Background Elements -->
    <div class="absolute inset-0 opacity-10">
      <div
        class="absolute top-20 left-20 w-72 h-72 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse"
      ></div>
      <div
        class="absolute top-40 right-20 w-96 h-96 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"
      ></div>
      <div
        class="absolute bottom-20 left-40 w-80 h-80 bg-gradient-to-r from-orange-500 to-red-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-2000"
      ></div>
    </div>

    <!-- Hero Section -->
    <section
      class="relative z-10 flex items-center justify-center min-h-screen px-6 pt-20"
    >
      <div class="text-center max-w-5xl mx-auto lg:mt-5">
        <!-- Welcome Message -->
        <div
          class="mb-8 transform transition-all duration-1000 hover:scale-105"
        >
          <h1
            class="text-6xl md:text-8xl font-extrabold text-transparent bg-clip-text bg-white mb-4 animate-pulse"
          >
            Welcome
          </h1>
          <p
            class="text-2xl md:text-3xl text-white/90 font-light leading-relaxed"
          >
            To
          </p>
        </div>

        <!-- Exclusive Project Highlight -->
        <div class="mb-12 relative">
          <div
            class="absolute inset-0 bg-blue rounded-3xl blur-lg opacity-80 animate-pulse"
          ></div>
          <div
            class="relative bg-gradient-to-r from-white/20 to-white/10 backdrop-blur-xl border border-white/30 rounded-3xl p-8 md:p-12 shadow-2xl"
          >
            <div
              class="absolute top-0 right-0 w-32 h-32 bg-main rounded-full opacity-20 animate-spin-slow"
            ></div>
            <h2
              class="text-4xl md:text-6xl font-bold text-white mb-6 relative z-10"
            >
              HUTU
            </h2>
            <p
              class="text-3xl md:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400 font-semibold relative z-10"
            >
              Exclusive Properties
            </p>
            <div class="mt-10 flex justify-center gap-2">
              <span
                class="px-4 py-2 bg-blue text-white rounded-full text-sm font-semibold animate-bounce"
              >
                🏠 Premium Location
              </span>
              <span
                class="px-4 py-2 bg-yellow-500 text-white rounded-full text-sm font-semibold animate-bounce delay-300"
              >
                💎 Luxury Living
              </span>
            </div>
          </div>
        </div>

        <!-- Call to Action -->
        <div
          class="flex flex-col md:flex-row gap-6 justify-center items-center"
        >
          <!-- <button 
            @click="scrollToProperties"
            class="group relative px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 text-white font-semibold rounded-full shadow-lg hover:shadow-pink-500/50 transform hover:scale-110 transition-all duration-300 overflow-hidden animate-pulse"
          >
            <span class="relative z-10 flex items-center gap-2">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
              </svg>
              Explore Properties
            </span>
            <div class="absolute inset-0 bg-gradient-to-r from-orange-600 via-red-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button> -->

          <button
            @click="contactWhatsApp('HUTU EXCLUSIVE')"
            class="group px-8 py-4 border-2 border-gradient-to-r from-yellow-400 to-orange-500 text-white font-semibold rounded-full hover:bg-gradient-to-r hover:from-yellow-400 hover:to-orange-500 hover:text-black transition-all duration-300 flex items-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"
              />
            </svg>
            Chat with me on Whatsapp
          </button>
        </div>

        <!-- Floating Elements -->
        <div
          class="absolute top-1/4 left-1/4 w-4 h-4 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full animate-bounce delay-300"
        ></div>
        <div
          class="absolute top-1/3 right-1/3 w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full animate-bounce delay-700"
        ></div>
        <div
          class="absolute bottom-1/4 left-1/3 w-5 h-5 bg-gradient-to-r from-green-400 to-blue-400 rounded-full animate-bounce delay-1000"
        ></div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="relative z-10 py-20 px-6">
      <div class="container mx-auto max-w-6xl">
        <h3 class="text-4xl md:text-5xl font-bold text-center text-white mb-16">
          Why Choose
          <span
            class="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400"
            >HUTU</span
          >?
        </h3>

        <div class="grid md:grid-cols-3 gap-8">
          <div
            class="group bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-xl border border-white/30 rounded-2xl p-8 hover:from-purple-500/30 hover:to-pink-500/30 transition-all duration-300 transform hover:scale-105 hover:rotate-1"
          >
            <div class="text-purple-400 mb-4">
              <svg
                class="w-12 h-12 mx-auto"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                />
              </svg>
            </div>
            <h4 class="text-2xl font-bold text-white mb-3">Premium Quality</h4>
            <p class="text-white/80">
              Experience excellence with our carefully crafted properties
              designed for luxury living.
            </p>
          </div>

          <div
            class="group bg-gradient-to-br from-blue-500/20 to-cyan-500/20 backdrop-blur-xl border border-white/30 rounded-2xl p-8 hover:from-blue-500/30 hover:to-cyan-500/30 transition-all duration-300 transform hover:scale-105 hover:rotate-1"
          >
            <div class="text-blue-400 mb-4">
              <svg
                class="w-12 h-12 mx-auto"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z"
                />
              </svg>
            </div>
            <h4 class="text-2xl font-bold text-white mb-3">Exclusive Access</h4>
            <p class="text-white/80">
              Join an elite community with privileged access to premium
              properties and location.
            </p>
          </div>

          <div
            class="group bg-gradient-to-br from-orange-500/20 to-red-500/20 backdrop-blur-xl border border-white/30 rounded-2xl p-8 hover:from-orange-500/30 hover:to-red-500/30 transition-all duration-300 transform hover:scale-105 hover:rotate-1"
          >
            <div class="text-orange-400 mb-4">
              <svg
                class="w-12 h-12 mx-auto"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"
                />
              </svg>
            </div>
            <h4 class="text-2xl font-bold text-white mb-3">Prime Location</h4>
            <p class="text-white/80">
              Strategic location in the heart of the city with excellent
              connectivity and amenities.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Properties Section -->
    <section
      id="properties"
      class="relative z-10 py-20 px-6 bg-gradient-to-b from-transparent via-purple-900/20 to-black/60"
    >
      <div class="container mx-auto max-w-6xl">
        <h3 class="text-4xl md:text-5xl font-bold text-center text-white mb-4">
          Featured
          <span
            class="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400"
            >Properties</span
          >
        </h3>
        <p class="text-center text-white/80 mb-16 text-lg">
          🏆 Discover our exclusive collection of premium properties ✨
        </p>

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            v-for="property in properties"
            :key="property.id"
            class="property-card bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/30 rounded-3xl overflow-hidden hover:from-white/20 hover:to-white/10 transition-all duration-300 transform hover:scale-105 hover:rotate-1 group"
          >
            <div class="relative h-48 overflow-hidden">
              <img
                :src="property.image"
                :alt="property.title"
                class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"
              ></div>
              <div
                class="absolute top-4 right-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-1 rounded-full text-sm font-semibold animate-pulse"
              >
                {{ property.status }}
              </div>
              <div class="absolute bottom-4 left-4 text-white">
                <h4 class="text-xl font-bold mb-1">{{ property.title }}</h4>
                <p class="text-white/90 text-sm flex items-center gap-1">
                  <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                    />
                  </svg>
                  {{ property.location }}
                </p>
              </div>
            </div>

            <div class="p-6">
              <div class="flex justify-between items-center mb-4">
                <span
                  class="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400"
                  >{{ property.price }}</span
                >
                <span
                  class="text-white/70 text-xs bg-gradient-to-r from-purple-500/20 to-pink-500/20 px-3 py-1 rounded-full"
                  >{{ property.type }}</span
                >
              </div>

              <div class="grid grid-cols-3 gap-4 mb-6 text-center">
                <div class="text-white/80">
                  <div class="text-lg font-semibold text-white">
                    {{ property.bedrooms }}
                  </div>
                  <div class="text-xs">🛏️ Bedrooms</div>
                </div>
                <div class="text-white/80">
                  <div class="text-lg font-semibold text-white">
                    {{ property.bathrooms }}
                  </div>
                  <div class="text-xs">🚿 Bathrooms</div>
                </div>
                <div class="text-white/80">
                  <div class="text-lg font-semibold text-white">
                    {{ property.area }}
                  </div>
                  <div class="text-xs">📏 Sq Ft</div>
                </div>
              </div>

              <button
                @click="contactWhatsApp(property.title)"
                class="w-full bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 text-white font-semibold py-3 rounded-xl hover:from-orange-600 hover:via-red-600 hover:to-purple-600 transition-all duration-300 flex items-center justify-center gap-2 transform hover:scale-105"
              >
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"
                  />
                </svg>
                Buy now
              </button>
            </div>
          </div>
        </div>

        <div class="text-center mt-12">
          <button
            @click="contactWhatsApp('Properties for HUTU EXCLUSIVE')"
            class="px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 text-white font-semibold rounded-full shadow-lg hover:shadow-pink-500/50 transform hover:scale-110 transition-all duration-300 animate-pulse"
          >
            🔥 View More Properties 🔥
          </button>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section
      class="relative z-10 py-20 px-6 bg-gradient-to-t from-black via-purple-900/30 to-transparent"
    >
      <div class="container mx-auto max-w-4xl text-center">
        <h3 class="text-4xl md:text-5xl font-bold text-white mb-8">
          Ready to Get Started? 🚀
        </h3>
        <p class="text-xl text-white/90 mb-12">
          💬 Contact us today for exclusive access to premium properties
        </p>

        <div class="flex flex-col sm:flex-row gap-6 justify-center">
          <button
            @click="contactWhatsApp('To know more about all the properties in HUTU EXCLUSIVE')"
            class="px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-full shadow-lg hover:shadow-green-500/50 transform hover:scale-110 transition-all duration-300 flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"
              />
            </svg>
            💬 Chat me on WhatsApp
          </button>

          <button
            @click="scrollToTop"
            class="px-8 py-4 border-2 border-gradient-to-r from-purple-400 to-pink-400 text-white font-semibold rounded-full hover:bg-gradient-to-r hover:from-purple-400 hover:to-pink-400 hover:text-black transition-all duration-300"
          >
            ⬆️ Back to Top
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "HutuAdPage",
  data() {
    return {
      properties: [
        {
          id: 1,
          title: "MSHEL HUTU EXCLUSIVE",
          location: "Centenary City, Abuja",
          price: "₦7.78M",
          type: "Three Bedroom Terrace Duplex",
          status: "Available",
          bedrooms: 3,
          bathrooms: 4,
          area: "150",
          image: require("../assets/images/hutu-exclusive.jpg"),
        },
        {
          id: 2,
          title: "MSHEL HUTU EXCLUSIVE",
          location: "Centenary City, Abuja",
          price: "₦12.96M",
          type: "Four Bedroom Semi-Detached Duplex",
          status: "Available",
          bedrooms: 4,
          bathrooms: 5,
          area: "250",
          image: require("../assets/images/hutu-exclusive.jpg"),
        },
        {
          id: 3,
          title: "MSHEL HUTU EXCLUSIVE",
          location: "Centenary City, Abuja",
          price: "₦18.14M",
          type: "Four Bedroom Fully Detached Duplex",
          status: "Available",
          bedrooms: 4,
          bathrooms: 5,
          area: "350",
          image: require("../assets/images/hutu-exclusive.jpg"),
        },
        {
          id: 4,
          title: "MSHEL HUTU EXCLUSIVE",
          location: "Centenary City, Abuja",
          price: "₦25.92M",
          type: "Five Bedroom Fully Detached Duplex",
          status: "Available",
          bedrooms: 5,
          bathrooms: 6,
          area: "500",
          image: require("../assets/images/hutu-exclusive.jpg"),
        },
        {
          id: 5,
          title: "MSHEL HUTU EXCLUSIVE",
          location: "Centenary City, Abuja",
          price: "₦51.84M",
          type: "Block of Flats",
          status: "Available",
          bedrooms: 10,
          bathrooms: 10,
          area: "1000",
          image: require("../assets/images/hutu-exclusive.jpg"),
        },
      ],
    };
  },
  methods: {
    contactWhatsApp(propertyTitle = "") {
      const phoneNumber = "2349114446444"; // Replace with actual WhatsApp number
      const message = propertyTitle
        ? `Hi there! I'm interested in the ${propertyTitle} located in Centenary City, Abuja. Could you please share more details about availability, pricing, and payment plans?`
        : "Hi! I'm interested in MSHEL HUTU properties in Centenary City, Abuja. Could you kindly share more details about what's available?";

      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message
      )}`;
      window.open(whatsappUrl, "_blank");
    },

    scrollToProperties() {
      const element = document.getElementById("properties");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },

  mounted() {
    // Add smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute("href"));
        if (target) {
          target.scrollIntoView({
            behavior: "smooth",
          });
        }
      });
    });
  },
};
</script>

<style scoped>
/* Custom animations */
@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse-glow {
  0%,
  100% {
    box-shadow: 0 0 20px rgba(55, 75, 198, 0.3);
  }
  50% {
    box-shadow: 0 0 40px rgba(55, 75, 198, 0.6);
  }
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}

.animate-pulse-glow {
  animation: pulse-glow 2s ease-in-out infinite;
}

/* Glassmorphism effect */
.backdrop-blur-xl {
  backdrop-filter: blur(20px);
}

/* Property card hover effects */
.property-card {
  transition: all 0.3s ease;
}

.property-card:hover {
  transform: translateY(-5px);
}

/* Smooth transitions */
* {
  transition: all 0.3s ease;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

::-webkit-scrollbar-thumb {
  background: rgba(55, 75, 198, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(55, 75, 198, 0.8);
}
</style>
